module.exports = __webpack_public_path__ + "img/logo.e6a368c3.jpg";